import Plausible from 'plausible-tracker'

import { useConfig } from '@/composables/useConfig'
import { useCurUser } from '@/composables/useCurUser'
import { useRequest } from '@/composables/useRequest'

// Use a rollup to combine global and tenant-specific plausible metrics in separate sites
const hostname_parts = location.hostname.split('.')
let generic_hostname = null
if (hostname_parts[hostname_parts.length - 1] === 'localhost') {
  generic_hostname = 'localhost'
} else if (hostname_parts.length > 2) {
  generic_hostname = hostname_parts.slice(-2).join('.')
}
const domain = generic_hostname ? `${location.hostname},${generic_hostname}` : location.hostname

const { trackPageview: plausibleTrackPageview, trackEvent: plausibleTrackEvent } = Plausible({
  domain: domain,
  apiHost: location.origin,
  trackLocalhost: true,
})

const useTracker = () => {
  const { hasRole } = useCurUser()
  const curRequest = useRequest()
  const config = useConfig()
  const isEnabled = config.ENABLE_PLAUSIBLE
  const trackPageview = (data = {}, options = {}) => {
    if (!isEnabled) return
    plausibleTrackPageview(data, {
      ...options,
      props: {
        request_ref: curRequest.getRequestRef?.value,
        owner: curRequest.data?.owner.is_self ?? false,
        has_submitter_role: hasRole('submitter'),
        borrower: !!curRequest.data?.borrower?.is_self,
        has_borrower_role: hasRole('borrower'),
        valuer: curRequest.data?.valuer?.is_self ?? false,
        has_valuer_role: hasRole('valuer'),
        module: curRequest.data?.valuation_type as string,
      },
    })
  }
  const trackEvent = (data = {}, options = {}) => {
    if (!isEnabled) return
    // @ts-expect-error: Handle types
    plausibleTrackEvent(data, {
      ...options,
      props: {
        request_ref: curRequest.getRequestRef?.value,
        owner: curRequest.data?.owner?.is_self,
        has_submitter_role: hasRole('submitter'),
        borrower: curRequest.data?.borrower?.is_self,
        has_borrower_role: hasRole('borrower'),
        valuer: curRequest.data?.valuer?.is_self,
        has_valuer_role: hasRole('valuer'),
        module: curRequest.data?.valuation_type,
      },
    })
  }
  return { trackPageview, trackEvent }
}

export default useTracker
